export default {"src":"/_next/static/media/location.ad6507e0.svg","height":12,"width":11};